import React, {Component} from "react";
import {Row, Col, Collapse} from 'reactstrap';
import '../Review.css';

export default class ReviewMapPositions extends Component {

    constructor(props) {
       super(props);
       this.state = {
           isMappedOccupationsOpened: false,
           isMappedSeniorityOpened: false
       }
    }

    getOccupationsDisplayValue = (occupation) => {
        let mappedOccupation = this.props.mapOccupationOptions.filter(option => option.label === occupation.label);
        if (mappedOccupation.length > 0)
            return mappedOccupation[0].label;
        else
            return '';
    }

    getSenoirityDisplayValue = (senoirity) => {
        let mappedSenoirity = this.props.mapSeniorityOptions.filter(option => option.label === senoirity.label);
        if (mappedSenoirity.length > 0)
            return mappedSenoirity[0].label;
        else
            return '';
    }

    render() {
        let { allOccupationsMapping, allSeniorityMapping } = this.props.mapPositions;
        let {isMappedOccupationsOpened, isMappedSeniorityOpened} = this.state;
        let noOfOccupationsMapped = allOccupationsMapping.filter(occupationsMapping => occupationsMapping.column!=="").length;
        let noOfSeniorityMapped = allSeniorityMapping.filter(seniorityMapping => seniorityMapping.column!=="").length;
        return (<div>
                <div className="review-sub-section">
                    <Row>
                        <Col sm="11" md="11" className="review-sub-section-heading">
                          Mapped {noOfOccupationsMapped} of {allOccupationsMapping.length}  positions to occupations categories
                        </Col>
                        <Col sm="1" md="1" className={isMappedOccupationsOpened ? 'rotate-arrow' : 'text-center'}> 
                        <i className={(isMappedOccupationsOpened ? 'flaticon-down-arrow ' : 'flaticon-down-arrow').concat(' review-flaticon-down-arrow cursor-pointer')}  
                            onClick={ () => {
                            this.setState({isMappedOccupationsOpened : !isMappedOccupationsOpened});
                        }}/>
                        </Col>
                    </Row>
                    <Collapse isOpen={isMappedOccupationsOpened}>
                    <div className="mt30 mapped-review-records">
                    {allOccupationsMapping.map((occupationsMapping, index) => {
                            return (<div key={index} className={'review-mapped-column '.concat(index === 0 ? ' ' : 'mt10')}>
                            <span style={{ fontWeight: '600' }}>
                             {occupationsMapping.value}
                            </span>
                             {occupationsMapping.column!=="" ? <span><span> mapped to </span>
                            <span style={{ fontWeight: '600' }}>{this.getOccupationsDisplayValue(occupationsMapping.column)}</span>
                            </span>: <span> left unmapped</span>}
                        </div>
                            )
                        })}
                    </div>
                    </Collapse>
                </div>
           

                {/* Mapped senority levels */}
                <div className="review-sub-section">
                    <Row>
                        <Col sm="11" md="11" className="review-sub-section-heading">
                           Mapped {noOfSeniorityMapped} of {allSeniorityMapping.length}  positions to job categories
                        </Col>
                        <Col sm="1" md="1" className={isMappedSeniorityOpened ? 'rotate-arrow' : 'text-center'}> 
                        <i className={(isMappedSeniorityOpened ? 'flaticon-down-arrow ' : 'flaticon-down-arrow').concat(' review-flaticon-down-arrow cursor-pointer')}  
                            onClick={ () => {
                            this.setState({isMappedSeniorityOpened : !isMappedSeniorityOpened});
                        }}/>
                        </Col>
                    </Row>
                    <Collapse isOpen={isMappedSeniorityOpened}>
                    <div className="mt30 mapped-review-records">
                    {allSeniorityMapping.map((seniorityMapping, index) => {
                            return (<div key={index} className={'review-mapped-column '.concat(index === 0 ? ' ' : 'mt10')}>
                            <span style={{ fontWeight: '600' }}>
                             { !seniorityMapping.value || seniorityMapping.value===undefined||seniorityMapping.value===null ||seniorityMapping.value==="null"|| seniorityMapping.value==="undefined"? 
                                 seniorityMapping.value="empty"
                                :
                                  seniorityMapping.value
                                } 
                            </span>
                             {seniorityMapping.column!=="" ? <span><span> mapped to </span>
                            <span style={{ fontWeight: '600' }}>{this.getSenoirityDisplayValue(seniorityMapping.column)}</span>
                            </span>: <span> left unmapped</span>}
                        </div>
                            )
                        })}
                    </div>
                    </Collapse>
                </div>
                </div>
                )
    }
}
